import React, { useState } from "react";
import { Snowflake, Gift, X } from "lucide-react";
import { useSite } from "../../context/SiteContext";

const inSeason = (d = new Date()) => (d.getMonth() === 11) || (d.getMonth() === 0 && d.getDate() <= 2);
const seasonKey = () => { const d = new Date(); return `sw_holiday_closed_${d.getMonth() === 0 ? d.getFullYear() - 1 : d.getFullYear()}`; };

const HolidayBanner = () => {
  const { content, t } = useSite();
  const [closed, setClosed] = useState(() => localStorage.getItem(seasonKey()) === "1");
  const mode = content?.holiday_banner || "auto";
  if (closed || mode === "off" || (mode === "auto" && !inSeason())) return null;
  const close = () => { localStorage.setItem(seasonKey(), "1"); setClosed(true); };
  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-[#0b5f56] via-[#0e8c7f] to-[#0b5f56] text-white" data-testid="holiday-banner">
      <div className="mx-auto flex max-w-[1346px] items-center justify-center gap-2.5 px-10 py-2 text-[13.5px] font-semibold sm:text-[14.5px]">
        <Snowflake size={15} className="shrink-0 animate-[spin_9s_linear_infinite] text-[#c9f3ea]" />
        <span data-testid="holiday-banner-text">{t("Happy Holidays from StripWise!")}</span>
        <Gift size={15} className="hidden shrink-0 text-[#ffd9a8] sm:block" />
        <span className="hidden text-white/80 md:inline">· {t("Thank you for being part of our community.")}</span>
      </div>
      <button onClick={close} className="absolute right-3 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full text-white/80 transition-colors hover:bg-white/15 hover:text-white" aria-label="Close" data-testid="holiday-banner-close"><X size={15} /></button>
    </div>
  );
};

export default HolidayBanner;
